import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

export function addBuyer(buyerData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(buyerData);
  let response = axios.post(`${API_END_POINT}/company/buyer/add`, body, config);

  return response;
}

export function getAllBuyers(params) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = params;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/company/buyer/get-buyer/company/${companyId}/limit=${
      limit && limit
    }`,
    config
  );
  return response;
}

export function getSpecificBuyer(buyerId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/company/buyer/get-buyer/${buyerId}`,
    config
  );
  return response;
}

export function deleteBuyer(buyerIdtoDelete) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.delete(
    `${API_END_POINT}/company/buyer/delete/${buyerIdtoDelete}`,
    config
  );
  return response;
}

export function updateBuyer(BuyerIdtoEdit, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(updatedData);
  let response = axios.put(
    `${API_END_POINT}/company/buyer/edit/${BuyerIdtoEdit}`,
    body,
    config
  );
  return response;
}
